import {isCetecIntegrationEnabled} from '@/matic/config/features';
import {useAppContext} from '@/matic/providers/AppProvider';
import {usePartObjectType} from './usePartObjectType';

/**
 * One availability answer for every Procurement entrance.
 *
 * The feature flag opts the tenant in; a resolved ERP-bound Part type makes
 * the destination useful. Keeping this in one hook prevents the expanded and
 * collapsed sidebars from exposing different navigation.
 */
export function useProcurementAvailability() {
  const {tenantId} = useAppContext();
  const {syncedPart} = usePartObjectType();

  return (
    Boolean(tenantId) &&
    isCetecIntegrationEnabled(tenantId!) &&
    Boolean(syncedPart)
  );
}
